module.exports = __webpack_public_path__ + "static/media/storage-stacks.dc93ccca.png";